// Google Maps JS API をモーダル初回起動時に一度だけ遅延ロードするシングルトン
let mapsPromise = null

export function loadGoogleMaps (apiKey) {
  if (window.google && window.google.maps) return Promise.resolve()
  if (mapsPromise) return mapsPromise

  mapsPromise = new Promise((resolve, reject) => {
    const callbackName = '__caresulInitGoogleMaps'
    window[callbackName] = () => {
      delete window[callbackName]
      resolve()
    }
    const script = document.createElement('script')
    const params = new URLSearchParams({
      key: apiKey,
      callback: callbackName,
      loading: 'async',
    })
    script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`
    script.async = true
    script.defer = true
    script.onerror = () => {
      mapsPromise = null
      reject(new Error('Failed to load Google Maps JS API'))
    }
    document.head.appendChild(script)
  })
  return mapsPromise
}
